import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const manageVehiclesActions = {
  FETCH_ALL_VEHICLES: 'FETCH_ALL_VEHICLES',
  DELETE_VEHICLE: 'DELETE_VEHICLE',
  ADD_NEW_VEHICLE: 'ADD_NEW_VEHICLE',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  IMAGE_FILE_UPLOADED: 'IMAGE_FILE_UPLOADED',
  GET_VEHICLE_TYPES: 'GET_VEHICLE_TYPES',
  GET_VENDOR_NAMES: 'GET_VENDOR_NAMES',
  UPDATE_FILTER_FIELDS: 'UPDATE_FILTER_FIELDS',
  TOGGLE_MODAL_STATE: 'TOGGLE_MODAL_STATE',
  EDIT_VEHICLE_DATA: 'EDIT_VEHICLE_DATA',
  UPDATE_VEHICLE_DATA: 'UPDATE_VEHICLE_DATA',
  VEHICLE_IMAGES_UPLOADED: 'VEHICLE_IMAGES_UPLOADED',
  DELETE_VEHICLE_IMAGE: 'DELETE_VEHICLE_IMAGE'
};

export const getVendorNamesDataAction = payload => ({
  type: manageVehiclesActions.GET_VENDOR_NAMES,
  payload
});

export const getVehiclesDataAction = payload => ({
  type: manageVehiclesActions.FETCH_ALL_VEHICLES,
  payload
});

export const updatePageNumber = payload => ({
  type: manageVehiclesActions.UPDATE_PAGE_NUMBER,
  payload
});

export const addNewVehicleAction = payload => ({
  type: manageVehiclesActions.ADD_NEW_VEHICLE,
  payload
});

export const imageFileUploadAction = payload => ({
  type: manageVehiclesActions.IMAGE_FILE_UPLOADED,
  payload
});

export const vehicleImagesUploadAction = payload => ({
  type: manageVehiclesActions.VEHICLE_IMAGES_UPLOADED,
  payload
});

export const getVehicleTypesAction = payload => ({
  type: manageVehiclesActions.GET_VEHICLE_TYPES,
  payload
});

export const getFilterFieldUpdateAction = payload => ({
  type: manageVehiclesActions.UPDATE_FILTER_FIELDS,
  payload
});

export const getUpdateVehicleDataAction = payload => ({
  type: manageVehiclesActions.UPDATE_VEHICLE_DATA,
  payload
});

export const deleteVehicleImage = (index, clearAll) => (
  dispatch: Function,
  getState: Function
) => {
  const { manageVehiclesState } = getState();
  const { vehicleS3Urls } = manageVehiclesState;
  let vehicleS3UrlsCopy = [...vehicleS3Urls];
  if (clearAll) {
    vehicleS3UrlsCopy = [];
  } else {
    vehicleS3UrlsCopy.splice(index, 1);
  }

  dispatch({
    type: manageVehiclesActions.DELETE_VEHICLE_IMAGE,
    payload: { vehicleS3Urls: vehicleS3UrlsCopy }
  });
};

export const deleteImageFile = imageFileType => (
  dispatch: Function,
  getState: Function
) => {
  dispatch(
    imageFileUploadAction({
      imageFileType,
      fileUrl: null,
      isLoading: false,
      isLoaded: true
    })
  );
};

export const updateFilterFields = (fieldType, fieldVal) => dispatch => {
  dispatch(getFilterFieldUpdateAction({ [fieldType]: fieldVal }));
};

export const toggleModalState = modalState => dispatch => {
  dispatch({
    type: manageVehiclesActions.TOGGLE_MODAL_STATE,
    payload: { isModalOpen: modalState }
  });

  if (!modalState) {
    dispatch({
      type: manageVehiclesActions.EDIT_VEHICLE_DATA,
      payload: { toEditVehicle: null }
    });
  } else {
    dispatch({
      type: manageVehiclesActions.ADD_NEW_VEHICLE,
      payload: { newVehicleAdded: false }
    });
  }
};

export const editVehicle = vehicleData => dispatch => {
  dispatch({
    type: manageVehiclesActions.EDIT_VEHICLE_DATA,
    payload: {
      toEditVehicle: vehicleData,
      isModalOpen: true,
      vehicleS3Urls: vehicleData.vehicleS3Urls || [],
      uploadedFiles: {
        rcFrontS3Url: vehicleData.rcFrontS3Url || null,
        rcBackS3Url: vehicleData.rcBackS3Url || null,
        vehicleFrontViewS3Url: vehicleData.vehicleFrontViewS3Url || null,
        vehicleRearViewS3Url: vehicleData.vehicleRearViewS3Url || null,
        vehicleRightViewS3Url: vehicleData.vehicleRightViewS3Url || null,
        vehicleLeftViewS3Url: vehicleData.vehicleLeftViewS3Url || null
      }
    }
  });
};

export const toKeyValPair = inputArray => {
  return inputArray.map(item => {
    return {
      key: `${item.type}(${item.length} ft)`,
      value: { id: item.id, capacity: item.maxWeight }
    };
  });
};

export const getVehicleTypes = () => (dispatch: Function, getState) => {
  const { manageVehiclesState } = getState();
  const { vehicleTypesOptions } = manageVehiclesState;
  const defaultVal = {
    vehicleTypesOptions: null
  };
  if (vehicleTypesOptions) {
    return;
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getVehicleTypes',
    method: 'GET',
    replaceParamsArr: [
      { key: 'detailed', val: true },
      { key: 'includeInactive', val: false }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getVehicleTypesAction({
            vehicleTypesOptions: res.payload
              ? res.payload.map(item => ({
                  label: `${item.type} (${item.length || '-'}, ${item.breadth ||
                    '-'}, ${item.height || '-'}) ft`,
                  ...item
                }))
              : res.payload
          })
        );
      } else {
        dispatch(getVehicleTypesAction(defaultVal));
      }
    },
    failureCb: res => {
      dispatch(getVehicleTypesAction(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get vehicle type'
      );
    },
    catchCb: res => {
      dispatch(getVehicleTypesAction(defaultVal));
      toastr.error('Something went wrong!', 'Could not get vehicle type');
    }
  };

  return makeApiCall(requestObj);
};

export const getVendorNames = () => dispatch => {
  dispatch(
    getVendorNamesDataAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehiclesGetVendorNames',
    method: 'GET',
    replaceParamsArr: [{ key: 'vendorStatus', val: 'ACTIVE' }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getVendorNamesDataAction({
            isLoading: false,
            isLoaded: true,
            allVendorNames:
              res.payload &&
              res.payload.map(item => ({
                label: item.vendorName,
                value: item.id
              }))
          })
        );
      } else {
        dispatch(
          getVendorNamesDataAction({
            isLoading: false,
            isLoaded: true,
            allVendorNames: null // change this to null OR remove this
          })
        );
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not get vendors'
        );
      }
    },
    failureCb: res => {
      dispatch(
        getVendorNamesDataAction({
          isLoading: false,
          isLoaded: true,
          allVendorNames: null // change this to null OR remove this
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get vendors'
      );
    },
    catchCb: res => {
      dispatch(
        getVendorNamesDataAction({
          isLoading: false,
          isLoaded: true,
          allVendorNames: null // change this to null OR remove this
        })
      );
      toastr.error('Something went wrong!', 'Could not get vendors');
    }
  };

  return makeApiCall(requestObj);
};

export const fetchAllVehicles = () => (dispatch, getState) => {
  const { manageVehiclesState } = getState();

  dispatch(
    getVehiclesDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  if (!manageVehiclesState.filters.vendorId) {
    return;
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehiclesFetchVehicles',
    method: 'GET',
    replaceParamsArr: [
      { key: 'pageNo', val: manageVehiclesState.pageNumber },
      { key: 'pageSize', val: manageVehiclesState.pageSize },
      { key: 'vendorId', val: manageVehiclesState.filters.vendorId },
      { key: 'vehicleLegType', val: manageVehiclesState.filters.legType },
      {
        key: 'vehiclePartnerType',
        val: manageVehiclesState.filters.partnerType
      },
      {
        key: 'vehicleStatus',
        val: manageVehiclesState.filters.vehicleStatus
      }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getVehiclesDataAction({
            isLoading: false,
            isLoaded: true,
            allVehiclesData: res.payload
          })
        );
      } else {
        dispatch(
          getVehiclesDataAction({
            isLoading: false,
            isLoaded: true,
            allVehiclesData: null // change this to null OR remove this
          })
        );
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not get vehicles'
        );
      }
    },
    failureCb: res => {
      dispatch(
        getVehiclesDataAction({
          isLoading: false,
          isLoaded: true,
          allVehiclesData: null // change this to null OR remove this
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get vehicles'
      );
    },
    catchCb: res => {
      dispatch(
        getVehiclesDataAction({
          isLoading: false,
          isLoaded: true,
          allVehiclesData: null // change this to null OR remove this
        })
      );
      toastr.error('Something went wrong!', 'Could not get vehicles');
    }
  };

  return makeApiCall(requestObj);
};

/**
 * This function is to upload RC and Vehicle Images
 *
 * @param {string} imageFileType
 * @param imageFile
 * @param {string} vehicleNumber
 * @param {function} cb
 * @returns {function(...[*]=)}
 */
export const uploadImage = (
  imageFileType,
  imageFile,
  vehicleNumber,
  cb = () => {
    // empty function used as default callback function
  }
) => (dispatch: Function) => {
  cb();
  if (!imageFile) {
    return;
  }
  if (!vehicleNumber) {
    toastr.error('Error', 'Please enter vehicle number');
    return;
  }

  dispatch(
    imageFileUploadAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const formData = new FormData();
  formData.append('multipartFile', imageFile);
  formData.append('vehicleNumber', vehicleNumber);

  let isRcFile = false;

  if (
    imageFileType &&
    (imageFileType === 'rcFrontS3Url' || imageFileType === 'rcBackS3Url')
  ) {
    isRcFile = true;
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isRcFile
      ? 'manageVehiclesUploadRc'
      : 'manageVehiclesUploadImage',
    postFormData: true,
    data: formData,
    contentType: undefined,
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          imageFileUploadAction({
            imageFileType,
            fileUrl: res.payload,
            isLoading: false,
            isLoaded: true
          })
        );
      } else {
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not upload file'
        );
      }
      dispatch(
        imageFileUploadAction({
          isLoading: false,
          isLoaded: true
        })
      );
    },
    failureCb: res => {
      dispatch(
        imageFileUploadAction({
          isLoading: false,
          isLoaded: true
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not upload file'
      );
    },
    catchCb: () => {
      dispatch(
        imageFileUploadAction({
          isLoading: false,
          isLoaded: true
        })
      );
      toastr.error('Something went wrong!', 'Could not upload file');
    }
  };

  makeApiCall(requestObj);
};

export const uploadVehicleImages = (
  vehicleImage,
  vehicleNumber,
  cb = () => {
    // empty function used as default callback function
  }
) => (dispatch: Function) => {
  cb();
  if (!vehicleNumber) {
    toastr.error('Error', 'Please enter vehicle number');
    return;
  }

  dispatch(
    vehicleImagesUploadAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const formData = new FormData();

  formData.append('multipartFile', vehicleImage);

  formData.append('vehicleNumber', vehicleNumber);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehiclesUploadImage',
    method: 'POST',
    postFormData: true,
    data: formData,
    contentType: '',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          vehicleImagesUploadAction({
            vehicleS3Urls: res.payload,
            isLoading: false,
            isLoaded: true
          })
        );
      } else {
        dispatch(
          vehicleImagesUploadAction({
            isLoading: false,
            isLoaded: true
          })
        );
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not upload file'
        );
      }
    },
    failureCb: res => {
      dispatch(
        vehicleImagesUploadAction({
          isLoading: false,
          isLoaded: true
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not upload file'
      );
    },
    catchCb: () => {
      dispatch(
        vehicleImagesUploadAction({
          isLoading: false,
          isLoaded: true
        })
      );
      toastr.error('Something went wrong!', 'Could not upload file');
    }
  };

  makeApiCall(requestObj);
};

export const addNewVehicle = newVehicleData => (dispatch: Function) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehicles',
    method: 'POST',
    data: newVehicleData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          addNewVehicleAction({
            isModalOpen: false,
            uploadedFiles: null,
            vehicleS3Urls: [],
            newVehicleAdded: true
          })
        );
        dispatch(fetchAllVehicles());
      } else {
        dispatch(
          addNewVehicleAction({
            newVehicleAdded: false
          })
        );
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not add vehicle'
        );
      }
    },
    failureCb: res => {
      dispatch(
        addNewVehicleAction({
          newVehicleAdded: false
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not add vehicle'
      );
    },
    catchCb: res => {
      dispatch(
        addNewVehicleAction({
          newVehicleAdded: false
        })
      );
      toastr.error('Something went wrong!', 'Could not add vehicle');
    }
  };

  return makeApiCall(requestObj);
};

export const updateVehicleData = vehicleData => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehicles',
    method: 'PUT',
    data: vehicleData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getUpdateVehicleDataAction({
            isModalOpen: false,
            uploadedFiles: null,
            vehicleS3Urls: [],
            newVehicleAdded: true,
            toEditVehicle: null
          })
        );
        dispatch(fetchAllVehicles());
      } else {
        dispatch(
          addNewVehicleAction({
            newVehicleAdded: false
          })
        );
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not add vehicle'
        );
      }
    },
    failureCb: res => {
      dispatch(
        addNewVehicleAction({
          newVehicleAdded: false
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not add vehicle'
      );
    },
    catchCb: res => {
      dispatch(
        addNewVehicleAction({
          newVehicleAdded: false
        })
      );
      toastr.error('Something went wrong!', 'Could not add vehicle');
    }
  };

  return makeApiCall(requestObj);
};

export const deleteVehicle = vehicleId => (dispatch: Function) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehicles',
    method: 'DELETE',
    replaceParamsArr: [{ key: 'id', val: vehicleId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(fetchAllVehicles());
      } else {
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Could not delete vehicle'
        );
      }
    },
    failureCb: res => {
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not delete vehicle'
      );
    },
    catchCb: res => {
      toastr.error('Something went wrong!', 'Could not delete vehicle');
    }
  };

  makeApiCall(requestObj);
};

/**
 * updateVehicleAvailability: To update vehicle availability details using PUT api
 *
 * @param vehicleData
 * @returns {function(Function): null|Promise<void>}
 */
export const updateVehicleAvailability = vehicleData => dispatch => {
  toastr.light('Please Wait!', 'Submitting...');

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'manageVehicles',
    method: 'PUT',
    data: vehicleData,
    successCb: res => {
      if (res && res.status === 'SUCCESS') {
        toastr.removeByType('light');
        toastr.success(
          'Success',
          'Successfully Updated Vehicle Availability Details!'
        );
        dispatch(fetchAllVehicles());
      } else {
        toastr.removeByType('light');
      }
    },
    failureCb: res => {
      toastr.removeByType('light');
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not update vehicle availability!'
      );
    },
    catchCb: res => {
      toastr.removeByType('light');
      toastr.error(
        'Something went wrong!',
        'Could not update vehicle availability!'
      );
    }
  };

  return makeApiCall(requestObj);
};
